import { useCallback, useState } from "react";
import Api, { FinanceContractClientsResponse } from "../../Api";
import EntitySearch from "../../parts/EntitySearch";
import Section from "../../parts/Section";
import EntityList from "../../parts/EntityList";
import BoolTabs from "../../parts/BoolTabs";
import { useNavigate, useSearchParams } from "react-router-dom";

const FinanceContractClients = () => {
  const [searchParams] = useSearchParams();
  const activeClients = searchParams.get("tab") === "ativos";
  const [data, setData] = useState<FinanceContractClientsResponse[] | null>(
    null
  );

  const searchReceipt = useCallback(
    (searchTerm: string, page: string) =>
      Api.financeContractClients(activeClients.toString(), searchTerm, page),
    [activeClients]
  );

  return (
    <>
      <div className="border-b">
        <Section className="p-4">
          <EntitySearch searchFunction={searchReceipt} setEntities={setData} />
        </Section>
      </div>

      <BoolTabs
        defaultTab={{ label: "Todos os clientes", value: "todos" }}
        alternateTab={{ label: "Com contrato ativo", value: "ativos" }}
        onChange={() => [setData(null)]}
      />

      <Section>
        <EntityList entities={data} Card={ClientCard} />
      </Section>
    </>
  );
};

export default FinanceContractClients;

const ClientCard = ({
  entity: { client, activeContracts, totalContracts },
}: {
  entity: FinanceContractClientsResponse;
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="border rounded-lg shadow-sm p-4 flex flex-col gap-2 cursor-pointer hover:bg-slate-50"
      onClick={() => navigate(`/financeiro/contratos/cliente/${client.uuid}`)}
    >
      <div className="overflow-scroll whitespace-nowrap no-scrollbar font-semibold">
        {client.name}
      </div>

      <div className="flex">
        <div className="bg-gray-100 text-gray-700 text-xs py-0.5 px-2 rounded-full flex gap-2">
          <div>Contratos</div>
          <div className="font-mono font-extrabold">
            <span>{activeContracts}</span>
            <span className="text-gray-400">/{totalContracts}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
